import { render, staticRenderFns } from "./DrilldownTableReport.vue?vue&type=template&id=12542744"
import script from "./DrilldownTableReport.vue?vue&type=script&lang=ts"
export * from "./DrilldownTableReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports